export default __webpack_public_path__ + "static/media/a037-10.f37e0342.svg";